import { Button, Flex, FontAwesomeIcon, Header, Modal, ModalBody, ModalFooter, ModalHeader } from "@nef/core"

import { NFN_OPS_EMAIL, NFN_OPS_EMAIL_HREF, NFN_OPS_TEL, NFN_OPS_TEL_HREF } from "../../constants/common"
import useAuthContext from "../../hooks/useAuthContext";

const RecordIsMissingModal = ({ isOpen, closeMissingModal }: any) => {
  const { handleLogOutUser } = useAuthContext();

  return (
    <Modal isOpen={isOpen} closeOnOutsideClick={false} size="md">
      <ModalHeader
        data-testid="modalHeader"
        title={
          <>
            <Flex>
              <FontAwesomeIcon iconSetClassName="fas" iconClassName="fa-exclamation-triangle" style={{ color: "crimson", marginRight: "1rem" }} />
              Missing Information
            </Flex>
          </>
        }
      />
      <ModalBody>
        <Header size={4}>Missing user information, contact NFN Operations.</Header>
        <br />
        <Header size={4}>
          <FontAwesomeIcon iconSetClassName="fas" iconClassName="fa-phone" style={{ marginRight: "1rem" }} />
          <a href={NFN_OPS_TEL_HREF}>{NFN_OPS_TEL}</a>
        </Header>
        <Header size={4}>
          <FontAwesomeIcon iconSetClassName="fas" iconClassName="fa-envelope" style={{ marginRight: "1rem" }} />
          <a href={NFN_OPS_EMAIL_HREF}>{NFN_OPS_EMAIL}</a>
        </Header>
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeMissingModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default RecordIsMissingModal
